import { captureException } from '@sentry/browser';
import { useCallback } from 'react';

const useSentryCaptureException = () => {
  const sentryCaptureException = useCallback(
    (error: Error, extra?: Record<string, unknown>) => {
      captureException(error, { extra });
    },
    [],
  );

  return sentryCaptureException;
};

export default useSentryCaptureException;
